export const setEmailAddress = emailAddress => {
	return { type: 'SET_EMAIL_ADDRESS', emailAddress };
};